// extracted by mini-css-extract-plugin
module.exports = {"create_button":"CreateWorkOrderButton_create_button__1YwYM"};